import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import styled from 'styled-components';
import LoadingPhases from './LoadingSplashPhases';
import PropTypes from 'prop-types';

const LoadingSplash = ({ isLoading, text, overlay, children }) => (
    <StyledLoader
        active={isLoading}
        spinner={true}
        overlay={overlay}
        text={text}
        classNamePrefix={prefix}
    >
        {children}
    </StyledLoader>
);

LoadingSplash.propTypes = {
    overlay: PropTypes.bool,
    text: PropTypes.any, // (please use prepared or add new one to: ./LoadingPhases.js)
};

LoadingSplash.defaultProps = {
    overlay: false,
    text: LoadingPhases.default,
};

const prefix = 'StyledLoader_';

//
// see: https://www.npmjs.com/package/react-loading-overlay#styles-with-css
//
const StyledLoader = styled(LoadingOverlay)`
    .StyledLoader_overlay {
        cursor: wait;
        z-index: 99999999;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 10px;
    }
    &.StyledLoader_content {
        font-size: 21px;
    }
    .StyledLoader_spinner {
        position: relative !important;
        left: auto !important;
        right: auto !important;
    }
`;

export default LoadingSplash;
